import { createSelector } from 'reselect';
import { getUserEntitlement } from '../auth/selectors.js';
import type { AuthSlice } from '../auth/types.js';
import { getProjectEntitlement, type ProjectSlice } from '../project/index.js';

export type EntitlementSlice = ProjectSlice & AuthSlice;

export const getEntitlementValue = createSelector(
  getUserEntitlement,
  getProjectEntitlement,
  (userEntitlement, projectEntitlement) => projectEntitlement ?? userEntitlement
);

export const createEntitlementValueSelector = (entitlement: string) => (state: EntitlementSlice) =>
  getEntitlementValue(state, { entitlement });
